// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_mq-0";
export var animationContainer = "_mq-1";
export var itemPrice = "_mq-a";
export var itemizedContent = "_mq-9";
export var itemizedHeader = "_mq-7";
export var itemizedRow = "_mq-8";
export var itemizedSection = "_mq-6";
export var modalContent = "_mq-2";
export var orderName = "_mq-3";
export var refundOption = "_mq-4";
export var refundOptionsContainer = "_mq-5";
export var shippingLabel = "_mq-b";
export var totalRow = "_mq-c";